import { render } from "./UnboxBox.vue?vue&type=template&id=dc727d1e&scoped=true"
import script from "./UnboxBox.vue?vue&type=script&lang=js"
export * from "./UnboxBox.vue?vue&type=script&lang=js"

import "./UnboxBox.vue?vue&type=style&index=0&id=dc727d1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc727d1e"]])

export default __exports__